export enum ConsentType {
    BuildingConsent = 'BuildingConsent',
    ResourceConsent = 'ResourceConsent',
}
